import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import AuthLoader from '../Helper/AuthLoader';
import { setStudentFromLocalStorage, selectIsStudentAuthenticated, selectStudent } from '../../Store/studentAuthSlice';

/**
 * StudentLoginCheck - Route protection component for student routes
 * Ensures user is authenticated as a student before accessing protected routes
 */
const StudentLoginCheck = ({ element }) => {
  const dispatch = useDispatch();
  const [isLoaded, setIsLoaded] = useState(false);

  const isAuthenticated = useSelector(selectIsStudentAuthenticated);
  const student = useSelector(selectStudent);

  useEffect(() => {
    // Try to restore student from localStorage if not in state
    if (!student) {
      dispatch(setStudentFromLocalStorage());
    }
    setIsLoaded(true);
  }, [dispatch, student]);

  // Show loading spinner while checking auth state
  if (!isLoaded) {
    return <AuthLoader />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated || !student) {
    return <Navigate to="/student/login" replace />;
  }

  // Render the protected component
  return element;
};

StudentLoginCheck.propTypes = {
  element: PropTypes.node.isRequired,
};

export default StudentLoginCheck;
